/**
 * Pawello theme — global interactions.
 * Ported from the approved Pawello frontend prototype (assets/js/app.js),
 * with the localStorage cart replaced by Shopify's native AJAX Cart API.
 */
(function () {
  "use strict";

  var routes = (window.Pawello && window.Pawello.routes) || {};
  var strings = (window.Pawello && window.Pawello.strings) || {};

  /* ---------- Header scroll ---------- */

  function initHeaderScroll() {
    var header = document.querySelector("[data-header]");
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Mobile menu ---------- */

  function initMobileMenu() {
    var menuBtn = document.querySelector("[data-menu-open]");
    var menuClose = document.querySelector("[data-menu-close]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!menuBtn || !menu) return;

    var open = function () {
      menu.classList.add("is-open");
      document.body.classList.add("overlay-open");
    };
    var close = function () {
      menu.classList.remove("is-open");
      document.body.classList.remove("overlay-open");
    };
    menuBtn.addEventListener("click", open);
    if (menuClose) menuClose.addEventListener("click", close);
    menu.querySelectorAll("[data-mobile-nav-link]").forEach(function (a) {
      a.addEventListener("click", close);
    });
  }

  /* ---------- Search overlay ---------- */

  function initSearchOverlay() {
    var btn = document.querySelector("[data-search-open]");
    var overlay = document.querySelector("[data-search-overlay]");
    var closeBtn = document.querySelector("[data-search-close]");
    var input = document.querySelector("[data-search-input]");
    if (!btn || !overlay) return;

    var open = function () {
      overlay.classList.add("is-open");
      document.body.classList.add("overlay-open");
      window.setTimeout(function () {
        if (input) input.focus();
      }, 200);
    };
    var close = function () {
      overlay.classList.remove("is-open");
      document.body.classList.remove("overlay-open");
      if (input) input.value = "";
      var results = document.querySelector("[data-search-results]");
      if (results) results.innerHTML = '<p class="search-empty">' + strings.searchTypeToSearch + "</p>";
    };

    btn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });

    window.PawelloSearch = { open: open, close: close };
  }

  /* ---------- Cart drawer ---------- */

  function getCartRoot() {
    return document.querySelector("[data-cart-drawer-root]");
  }

  function openCartDrawer() {
    var overlay = document.querySelector("[data-cart-overlay]");
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!overlay || !drawer) return;
    overlay.classList.add("is-open");
    drawer.classList.add("is-open");
    document.body.classList.add("overlay-open");
  }

  function closeCartDrawer() {
    var overlay = document.querySelector("[data-cart-overlay]");
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!overlay || !drawer) return;
    overlay.classList.remove("is-open");
    drawer.classList.remove("is-open");
    document.body.classList.remove("overlay-open");
  }

  function bindCartDrawerEvents() {
    var openBtns = document.querySelectorAll("[data-cart-open]");
    openBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        openCartDrawer();
      });
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-close]") || e.target.closest("[data-cart-overlay]")) {
        closeCartDrawer();
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeCartDrawer();
    });

    document.addEventListener("click", function (e) {
      var row = e.target.closest("[data-cart-item]");
      if (!row) return;
      var key = row.dataset.cartItemKey;

      if (e.target.closest("[data-cart-remove]")) {
        changeCartItem(key, 0);
      } else if (e.target.closest("[data-qty-increase]")) {
        var valueEl = row.querySelector("[data-qty-value]");
        var next = parseInt(valueEl.textContent, 10) + 1;
        changeCartItem(key, next);
      } else if (e.target.closest("[data-qty-decrease]")) {
        var valueEl2 = row.querySelector("[data-qty-value]");
        var next2 = parseInt(valueEl2.textContent, 10) - 1;
        changeCartItem(key, next2);
      }
    });
  }

  function updateCartBadge(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("hidden", count === 0);
    });
  }

  function refreshCartDrawerMarkup() {
    if (!routes.cartUrl) return Promise.resolve();
    return fetch(routes.cartUrl + "?sections=cart-drawer")
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var freshRoot = doc.querySelector("[data-cart-drawer-root]");
        var currentRoot = getCartRoot();
        if (freshRoot && currentRoot) {
          currentRoot.innerHTML = freshRoot.innerHTML;
        }
      })
      .catch(function () {});
  }

  function changeCartItem(key, quantity) {
    fetch(routes.cartChangeUrl || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        return refreshCartDrawerMarkup();
      })
      .catch(function () {});
  }

  window.Pawello = window.Pawello || {};
  window.Pawello.cart = {
    open: openCartDrawer,
    close: closeCartDrawer,
    refresh: refreshCartDrawerMarkup,
    updateBadge: updateCartBadge,
  };

  /* ---------- Favorites (client-only, no backend) ---------- */

  var FAV_KEY = "pawello_favorites";

  function getFavorites() {
    try {
      return JSON.parse(localStorage.getItem(FAV_KEY)) || {};
    } catch (e) {
      return {};
    }
  }
  function setFavorites(favs) {
    localStorage.setItem(FAV_KEY, JSON.stringify(favs));
  }
  function isFavorite(handle) {
    return !!getFavorites()[handle];
  }
  function toggleFavorite(handle) {
    var favs = getFavorites();
    if (favs[handle]) {
      delete favs[handle];
    } else {
      favs[handle] = true;
    }
    setFavorites(favs);
    updateFavoritesBadge();
    return !!favs[handle];
  }
  function updateFavoritesBadge() {
    var count = Object.keys(getFavorites()).length;
    document.querySelectorAll("[data-favorites-count]").forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("hidden", count === 0);
    });
  }
  function syncFavoriteButtons() {
    document.querySelectorAll("[data-fav-toggle]").forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      var active = isFavorite(handle);
      btn.classList.toggle("is-active", active);
      var icon = btn.querySelector(".icon");
      if (icon) {
        icon.setAttribute("fill", active ? "currentColor" : "none");
      }
      btn.style.color = active ? "var(--color-terracotta)" : "";
    });
  }

  function initFavorites() {
    document.body.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-fav-toggle]");
      if (!btn) return;
      e.preventDefault();
      toggleFavorite(btn.dataset.productHandle);
      syncFavoriteButtons();
    });
    updateFavoritesBadge();
    syncFavoriteButtons();
  }

  window.Pawello.favorites = {
    getAll: getFavorites,
    isFavorite: isFavorite,
    toggle: toggleFavorite,
    sync: syncFavoriteButtons,
  };

  /* ---------- Product card touch support (no hover on mobile) ---------- */

  function initProductCardTouch() {
    document.body.addEventListener("click", function (e) {
      if (window.matchMedia("(hover: hover)").matches) return;
      var link = e.target.closest(".product-card__image-link");
      if (!link) return;
      var card = link.closest(".product-card");
      if (!card || card.dataset.touched === "1") return;
      e.preventDefault();
      card.dataset.touched = "1";
      card.classList.add("is-active");
      window.setTimeout(function () {
        card.classList.remove("is-active");
        delete card.dataset.touched;
      }, 1400);
    });
  }

  /* ---------- Scroll reveal ---------- */

  function initScrollReveal() {
    var els = document.querySelectorAll(".reveal, .reveal-stagger");
    if (!els.length || !("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initHeaderScroll();
    initMobileMenu();
    initSearchOverlay();
    bindCartDrawerEvents();
    initFavorites();
    initProductCardTouch();
    initScrollReveal();
  });

  document.addEventListener("shopify:section:load", initScrollReveal);
})();
